import { FC, ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initializeApiClient } from '@wellstone-solutions/api/instance';
import { Api } from '@wellstone-solutions/common';

import { onTokenRefresh } from './on-token-refresh';

const queryClient = new QueryClient();

Api.configure({
  baseURL: process.env.VITE_PATHFINDER_API_URL,
  version: Api.API_VERSIONS.V2,
  headers: {
    common: {
      'x-client-version': 'harbor,' + (process.env.VITE_HARBOR_VERSION ?? ''),
      'x-user-time-zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  },
  onTokenRefresh,
});

if (Api.Instance.v2()) initializeApiClient(Api.Instance.v2().axiosInstance);

interface ApiProviderProps {
  children: ReactNode;
}

const ApiProvider: FC<ApiProviderProps> = (props) => {
  const { children } = props;

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export { ApiProvider };
